import { BrowserRouter } from 'react-router-dom';

import { ApolloProvider } from '@apollo/client/react';
import { ThemeProvider } from '@primer/react'

import apolloClient from './utils/apollo_client';

import AuthenticationSlate from './components/AuthenticationSlate/AuthenticationSlate';
import ErrorSlate from './components/ErrorSlate/ErrorSlate';
import Header from './components/Header/Header';
import PageRouter from './components/pages/PageRouter';
import SignedOutView from './components/pages/SignedOutView/SignedOutView';
import Toast from './components/common/Toast/Toast';

import { ClientDataProvider, useClientContext } from './components/contexts/ClientData/ClientData';
import { UserDataProvider, useUserContext } from './components/contexts/UserData/UserData';
import { ToastProvider } from './components/common/Toast/ToastContext';
import { WorkspaceProvider } from './components/workspaces/WorkspaceContext/WorkspaceContext';

import './App.css';

export const App = () => {
  const {
    isAuthEnabled,
    isAdminDashboardEnabled,
    areInvitesEnabled,
    clientName,
    error: clientDetailsError
  } = useClientContext();
  const {
    userData, signedInState, error: authError, isAdmin 
  } = useUserContext();

  const error = clientDetailsError || authError;
  return (
    <div>
      <Header
        clientName={clientName}
        userProfile={userData}
        isAuthEnabled={isAuthEnabled}
        areInvitesEnabled={areInvitesEnabled}
        isAdminDashboardEnabled={isAdminDashboardEnabled}
        isAdminUser={isAdmin}
      />

      {!isAuthEnabled || signedInState === 'signed in' ? (
        <PageRouter />
      ) : signedInState === 'signed out' ? (
        <SignedOutView />
      ) : error ? (
        <ErrorSlate
          errorText="Something went wrong loading your information"
          subText={error}
        />
      ) : (
        <AuthenticationSlate />
      )}
      <Toast />
    </div>
  );
}

const AppWithDataAdapters = () => (
  <ApolloProvider client={apolloClient}>
    <ThemeProvider>
      <BrowserRouter>
        <ToastProvider>
          <ClientDataProvider>
            <UserDataProvider>
              <WorkspaceProvider>
                <App />
              </WorkspaceProvider>
            </UserDataProvider>
          </ClientDataProvider>
        </ToastProvider>
      </BrowserRouter>
    </ThemeProvider>
  </ApolloProvider>
)

export default AppWithDataAdapters;
